import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/mixins/Spaceable.ts
function Spaceable(baseClass) {
  class SpaceableMixin extends baseClass {
    async connectedCallback() {
      super.connectedCallback();
      this._spacingProperties = this._getContentSpacingProperties();
      if (this._spacingProperties?.colsLgUp) {
        this.setAttribute("data-cols-lg-up", this._spacingProperties.colsLgUp.toString());
      }
      if (this._spacingProperties?.colsMdUp) {
        this.setAttribute("data-cols-md-up", this._spacingProperties.colsMdUp.toString());
      }
      if (this._spacingProperties?.horizontal) {
        this.setAttribute("data-horizontal", this._spacingProperties.horizontal.toString());
      }
      if (this._spacingProperties?.type) {
        this.setAttribute("data-type", this._spacingProperties.type.toString());
      }
      if (this._spacingProperties?.align) {
        this.setAttribute("data-align", this._spacingProperties.align.toString());
      }
    }
    updated(_changedProperties) {
      super.updated(_changedProperties);
      if (_changedProperties.has("withSpacing")) {
        if (!this.withSpacing) {
          this.removeAttribute("data-cols-lg-up");
          this.removeAttribute("data-cols-md-up");
          this.removeAttribute("data-horizontal");
          this.removeAttribute("data-type");
        } else {
          if (this._spacingProperties?.colsLgUp) {
            this.setAttribute("data-cols-lg-up", this._spacingProperties.colsLgUp.toString());
          }
          if (this._spacingProperties?.colsMdUp) {
            this.setAttribute("data-cols-md-up", this._spacingProperties.colsMdUp.toString());
          }
          if (this._spacingProperties?.horizontal) {
            this.setAttribute("data-horizontal", this._spacingProperties.horizontal.toString());
          }
          if (this._spacingProperties?.type) {
            this.setAttribute("data-type", this._spacingProperties.type.toString());
          }
        }
      }
    }
    /**
     * override this method to specify the properties of the jb-content-spacing element, that will surround your component
     */
    _getContentSpacingProperties() {
      return {};
    }
  }
  __decorateClass([
    n({ type: Boolean, reflect: true })
  ], SpaceableMixin.prototype, "withSpacing", 2);
  return SpaceableMixin;
}

export {
  Spaceable
};
